import React from 'react';
import Lazyload from 'react-lazyload';
import './index.css';
import Detector from '../../../../utils/detector';
import { tantutravelHost } from '../../../../config';
import { sendStatsEvent } from '../../../statistics';

let checkSupportPageLink = false;
let version = Detector.browser.fullVersion.split('.');
const zuzucheVer = (version[0] >= 5 && version[1] >= 3 && version[2] >= 6);
const tantuVer = (version[0] >= 1 && version[1] >= 5);
if((Detector.browser.zuzuche && zuzucheVer) || (Detector.browser.tantutravel && tantuVer)){
  checkSupportPageLink = true;
}


export default class Videos extends React.Component {
  render(){
    let {videos, poi_uid} = this.props;
    if(!videos || !videos.length) 
      return null;

    return (
      <div className="videos">
        <h4>途途</h4>
        <ul className="videos-list">
          {
            videos.map((item, index) =>{
              if(index < 6){
                return <Item
                  key={index}
                  video={item.video_info}
                  hanldeItemClick={this.hanldeVideoItemClick} />;
              }
            })
          }
        </ul>
        {
          videos.length > 6 ? 
            <div className={`videos-more ${Detector.os.name}`} onClick={()=>{
              window.location = `${tantutravelHost}/video/?page=poi&id=${poi_uid}`;
            }}>
                查看更多<i className="icon icon-arrow"></i>
            </div> : null
        }
      </div>
    );
  }

  /**
   * 若是在探途旅行app和租租车app内，点击视频播放额，则进入原生播放界面；
   * 否则进入h5播放页
   */
  hanldeVideoItemClick = (video) =>{
    sendStatsEvent('poi_tutuvideoclick');
    if(checkSupportPageLink){
      this.showMediaView(video);
    }else{
      let videoId = video.video_id;
      window.location = `${tantutravelHost}/video/share?id=${videoId}`;
    }
  }

  //调用原生视频播放插件
  showMediaView = (video)=>{
    let apiParams = JSON.stringify({
      'poi_uid': this.props.poi_uid 
    });
    let url = `/video/?videoId=${encodeURIComponent(video.video_id)}&videoImage=${encodeURIComponent(video.cover_url)}&apiParams=${encodeURIComponent(apiParams)}&page=poi`;
    console.log(url);
    zzc.call('page_linkTo', {
      url: url,
      success: function (response) {
        console.log(response);
      }
    });
  }
   
  
}

function Item(props){
  let { video, hanldeItemClick } = props;
  let image = `${video.cover_url}` || 'https://imgcdn50.zuzuche.com/m_tantu_image/20171101/5d1cb7232871f5ccba3258b98f0871fe.jpg!/both/210x160';
  return (
    <li className="video-item" onClick={()=>{
      hanldeItemClick(video);
    }}>
      <Lazyload height="3.2rem">
        <div className="image" style={{backgroundImage:`url(${image})`}}></div>
      </Lazyload>
      <div className="content">
        <div className="tag"><i className="icon icon-video-small"></i></div>
        <h5>{video.video_desc || video.video_name}</h5> 
      </div>
    </li>
  );
}


// WEBPACK FOOTER //
// ./src/components/Poi2/Introduction/Videos/index.js